<template>
  <div
    class="cross-sell-cont"
    :class="{ 'ignore-theme': pageTheme !== 'dark-chrome' }"
  >
    <CrossSell
      :products="products"
      product-page-mode
      title="You might also like"
    />
  </div>
</template>

<script>
export default {
  props: {
    baseSku: { type: String, required: true },
    skuPrefix: { type: String, required: true },
  },

  setup() {
    const { pageTheme } = storeToRefs(usePageStore())

    return { pageTheme }
  },

  data: () => ({
    productGroups: [
      ['classics4', 'sierras', 'renegades', 'tempests', 'zephyrs', 'tokas', 'miras'],
      ['vulcans', 'airas', 'velans', 'ultras', 'forty2s', 'gts'],
      ['snipers', 'vanguards', 'ullrs'],
    ],
  }),

  computed: {
    products() {
      let products = []
      const nonMatchedGroups = []
      this.productGroups.forEach((group) => {
        if (group.includes(this.baseSku))
          products = [...group.filter((sku) => sku !== this.skuPrefix)]
        else nonMatchedGroups.push(group)
      })
      return [...products, ...nonMatchedGroups].flat()
    },
  },
}
</script>

<style lang="postcss">
.cross-sell-cont {
  @apply bg-white
    w-screen
    pt-sm pb-md;

  .is-dark-chrome-theme & {
    @apply bg-off-black;
  }
}
</style>
